import { render } from "./VersionAlert.vue?vue&type=template&id=9ae44570"
import script from "./VersionAlert.vue?vue&type=script&lang=js"
export * from "./VersionAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__